export const REGISTRATION_PATH = '/registration'
export const LOGIN_PATH = '/login'
export const FORGOT_PASSWORD_PATH = '/forgot-password'
export const ROOT_PATH = '/'
export const CHANGE_PASSWORD_PATH = '/change-password'
export const USERS_PATH = '/users'
export const SITES_PATH = '/sites'
export const SITES_MAP_PATH = '/sites/map'
export const MONITORING_PATH = '/monitoring'
export const REPORTS_PATH = '/reports'
export const REPORTS_EXPAND_PATH = '/reports/expand/:title'                        
export const CHANGE_EMAIL_PATH = '/change-email'
export const PROFILE_PATH = '/profile'
export const LEGAL_TERM_PATH = '/terms-and-use'
export const COOKIE_SETTINGS_PATH = '/cookie-settings'
export const SENSITIVE_SPECIES_PATH = '/sensitive-species'
export const BULK_IMPORT_ACCESS_PATH = '/bulk-import-access'
export const SYNC_FACTSHEETS_PATH = '/sync-factsheets'
export const editOnly = "editOnly"

export const SITE_PROPOSAL_PATH = '/site/:id'
export const SITE_PROPOSAL_ABOUT_PATH = `${SITE_PROPOSAL_PATH}/about`
export const SITE_PROPOSAL_MONITORING_PATH = `${SITE_PROPOSAL_PATH}/monitoring`
export const SITE_PROPOSAL_DETAILS_PATH = `${SITE_PROPOSAL_PATH}/details`
export const SITE_PROPOSAL_ASSESSMENT_PATH = `${SITE_PROPOSAL_PATH}/assessment`
export const SITE_PROPOSAL_CALCULATIONS_PATH = `${SITE_PROPOSAL_PATH}/kba-criterias`
export const SITE_PROPOSAL_MAP_PATH = `${SITE_PROPOSAL_PATH}/map`

export const SITE_REASSESSMENT_PATH = '/site/:id/reassessment/:siteHistoryId'
export const SITE_REASSESSMENT_ABOUT_PATH = `${SITE_REASSESSMENT_PATH}/about`
export const SITE_REASSESSMENT_MONITORING_PATH = `${SITE_REASSESSMENT_PATH}/monitoring`
export const SITE_REASSESSMENT_DETAILS_PATH = `${SITE_REASSESSMENT_PATH}/details`
export const SITE_REASSESSMENT_ASSESSMENT_PATH = `${SITE_REASSESSMENT_PATH}/assessment`
export const SITE_REASSESSMENT_CALCULATIONS_PATH = `${SITE_REASSESSMENT_PATH}/kba-criterias`
export const SITE_REASSESSMENT_MAP_PATH = `${SITE_REASSESSMENT_PATH}/map`

export const SITE_EDIT_ONLY_PATH = '/site/:id/edit-only/:siteHistoryId'
export const SITE_EDIT_ONLY_ABOUT_PATH = `${SITE_EDIT_ONLY_PATH}/about`
export const SITE_EDIT_ONLY_MONITORING_PATH = `${SITE_EDIT_ONLY_PATH}/monitoring`
export const SITE_EDIT_ONLY_DETAILS_PATH = `${SITE_EDIT_ONLY_PATH}/details`
export const SITE_EDIT_ONLY_ASSESSMENT_PATH = `${SITE_EDIT_ONLY_PATH}/assessment`
export const SITE_EDIT_ONLY_CALCULATIONS_PATH = `${SITE_EDIT_ONLY_PATH}/kba-criterias`
export const SITE_EDIT_ONLY_MAP_PATH = `${SITE_EDIT_ONLY_PATH}/map`

export const SITE_MONITORING_PATH = '/site/:id/monitoring/:monitoringId'
export const SITE_MONITORING_ABOUT_PATH = `${SITE_MONITORING_PATH}/about`
export const SITE_MONITORING_DETAILS_PATH = `${SITE_MONITORING_PATH}/details`
export const SITE_MONITORING_STATE_PATH = `${SITE_MONITORING_PATH}/state`
export const SITE_MONITORING_PRESSURE_PATH = `${SITE_MONITORING_PATH}/pressure`
export const SITE_MONITORING_RESPONSE_PATH = `${SITE_MONITORING_PATH}/response`
export const SITE_MONITORING_MAP_PATH = `${SITE_MONITORING_PATH}/guidance-and-tools`;
export const SITE_MONITORING_DASHBOARD_PATH = `${SITE_MONITORING_PATH}/overview`




export const buildAboutUrl = (id, siteHistoryIdOrEditOnlyId, path = null) => {
  return path === editOnly ? `/site/${id}/edit-only/${siteHistoryIdOrEditOnlyId}/about` : siteHistoryIdOrEditOnlyId ? `/site/${id}/reassessment/${siteHistoryIdOrEditOnlyId}/about` : `/site/${id}/about`
}

export const buildMapUrl = (id, siteHistoryIdOrEditOnlyId, path = null) => {
  return path === editOnly ? `/site/${id}/edit-only/${siteHistoryIdOrEditOnlyId}/map` : siteHistoryIdOrEditOnlyId ? `/site/${id}/reassessment/${siteHistoryIdOrEditOnlyId}/map` : `/site/${id}/map`
}

export const buildMonitoringUrl = (id, siteHistoryIdOrEditOnlyId, path = null) => {
  return path === editOnly ? `/site/${id}/edit-only/${siteHistoryIdOrEditOnlyId}/monitoring` : siteHistoryIdOrEditOnlyId ? `/site/${id}/reassessment/${siteHistoryIdOrEditOnlyId}/monitoring` : `/site/${id}/monitoring`
}

export const buildAssessmentUrl = (id, siteHistoryIdOrEditOnlyId, path = null) => {
  return path === editOnly ? `/site/${id}/edit-only/${siteHistoryIdOrEditOnlyId}/assessment` : siteHistoryIdOrEditOnlyId ? `/site/${id}/reassessment/${siteHistoryIdOrEditOnlyId}/assessment` : `/site/${id}/assessment`
}


export const buildCalculationsUrl = (id, siteHistoryIdOrEditOnlyId, path = null) => {
  return path === editOnly ? `/site/${id}/edit-only/${siteHistoryIdOrEditOnlyId}/kba-criterias` : siteHistoryIdOrEditOnlyId ? `/site/${id}/reassessment/${siteHistoryIdOrEditOnlyId}/kba-criterias` : `/site/${id}/kba-criterias`

}

export const buildDetailsUrl = (id, siteHistoryIdOrEditOnlyId, path = null) => {
  return path === editOnly ? `/site/${id}/edit-only/${siteHistoryIdOrEditOnlyId}/details` : siteHistoryIdOrEditOnlyId ? `/site/${id}/reassessment/${siteHistoryIdOrEditOnlyId}/details` : `/site/${id}/details`
}
export const buildMonitoringEvaluationUrl = (siteId, monitoringId) => {
  return `/site/${siteId}/monitoring/${monitoringId}/about`
}


export const buildReportsExpandPath = (title) => {
  return `/reports/expand/${title}`
}

export const buildMonitoringAboutUrl = (id, siteId) => {
  return `/site/${siteId}/monitoring/${id}/about`
}



